<template>
    <section class="campaign">
    <Header :user="currentUser" />


  <main class="main px-4"  :class="{ 'expand-main' : isMenuCollapse }" >
    <h4>Invoices Recovering</h4>
    <LoadingSpinner v-if="loading" />
    <div class="pt-2" v-if="!loading">
      <!-- filtros de busqueda -->
      <div class="card p-2 d-flex flex-row">
        <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper" v-if="oliverSalesLoaded">
          <div class="input-group-prepend">
            <span class="mr-2" id="inputGroup-sizing-sm"
              >Account Manager:</span
            >
          </div>
          <IndustrySearch
            :option_list="userOliverSales"
            :default_values="userOliverSale"
            :key="3"
            :multiple="false"
            :isDisabled="loading ||isAccountManager"
            @selected="selectOliverSale"
            class="form-control inline-table"
          />
        </div>

      </div>

      <div class="card p-2 d-flex flex-row my-3">
        <div>
          <span class="font-weight-bold">Total Clients: {{ totalClients }}</span>
        </div>
        <div>
          <span class="font-weight-bold ml-4">Total Recovering: {{ totalRecovering }}</span>
        </div>
        <div>
          <span class="font-weight-bold ml-4">Total Payment Declined: {{ totalPaymentDeclined }}</span>
        </div>
        <div>
          <span class="font-weight-bold ml-4">Total Amount: € {{ totalAmount }}</span>
        </div>
      </div>

      <div
        v-if="staleBlockedRubyClients.length"
        class="alert alert-danger py-2 px-3 mb-3"
        role="alert"
      >
        {{ staleBlockedRubyClients.length }} dossier{{ staleBlockedRubyClients.length > 1 ? 's' : '' }}
        Ruby bloqué{{ staleBlockedRubyClients.length > 1 ? 's' : '' }} depuis plus de
        {{ rubyBlockedAlertHours }}h — aucune créance n'a été envoyée à Ruby.
        <span class="d-block mt-1">
          {{ staleBlockedRubyClients.map((group) => group.client_name).join(', ') }}
        </span>
      </div>

      <div class="d-inline">
        <Tabs
          :tabs="recoveryFolderTabs"
          :tabSelected="selectedRecoveryFolderStatus"
          @change="changeRecoveryFolderTab($event)"
        />
      </div>

      <!-- invoices cards grouped by client -->
      <div class="mt-3">
        <div
          v-for="clientGroup in filteredGroupedInvoicesByClient"
          :key="clientGroup.client_id"
          class="card mb-3"
        >
          <!-- Card Header -->
          <div class="card-header d-flex justify-content-between align-items-center p-3">
            <div class="d-flex align-items-center">
              <h4 class="text-primary mb-0 mr-2" style="font-size: 1.5rem; font-weight: bold;">
                {{ clientGroup.client_name }}
              </h4>
              <span
              :class="clientGroup.active_licenses_by_client > 0 && clientGroup.payment_declined_days > 35 ? 'badge badge-danger font-weight-bold'
              : clientGroup.payment_declined_days > 30 ? 'text-muted'
              : 'text-muted'"
                style="font-size: 0.9rem;"
                >
                ({{ getClientInfoPlaceholder(clientGroup.active_licenses_by_client, clientGroup.payment_declined_days) }})
              </span>
              <h1 class="ml-2 font-weight-bold" :class="getClientStatusPlaceHolder(clientGroup.client_status)">
                {{ clientGroup.client_status == 'Pending deleted' ? 'Payment declined' : clientGroup.client_status }}
              </h1>
              <span
                v-if="!editingRecoveryStatus[clientGroup.client_id]"
                class="ml-3 recovery-status-text"
              >
                {{ clientGroup.judicial_recovery_status || 'Non débuté' }}
              </span>
              <select
                v-else
                class="form-control form-control-sm ml-3 recovery-status-select"
                v-model="recoveryStatusDraft[clientGroup.client_id]"
                :disabled="savingRecoveryStatus[clientGroup.client_id]"
              >
                <option value="0">Non débuté</option>
                <option value="2">Amiable (attente de réponse)</option>
                <option value="5">Amiable (OK paiement intégralité)</option>
                <option value="6">Amiable (OK paiement partiel + avoir)</option>
                <option value="7">Refus de payer</option>
                <option value="1">Judiciaire (ruby)</option>
                <option value="3">Injonction en cours (ruby)</option>
                <option value="4">Saisie attribution (ruby)</option>
                <option value="8">Recouvré (ruby)</option>
                <option value="9">Clôturé (ruby)</option>
              </select>
              <button
                v-if="!editingRecoveryStatus[clientGroup.client_id]"
                type="button"
                class="btn btn-link p-0 border-0 ml-2 recovery-status-edit"
                :disabled="savingRecoveryStatus[clientGroup.client_id]"
                @click="editRecoveryStatus(clientGroup.client_id)"
              >
                <i class="icon-pencil"></i>
              </button>
              <button
                v-else
                type="button"
                class="btn btn-link p-0 border-0 ml-2 recovery-status-confirm"
                :disabled="savingRecoveryStatus[clientGroup.client_id]"
                @click="saveRecoveryStatus(clientGroup, recoveryStatusDraft[clientGroup.client_id])"
              >
                <span v-if="savingRecoveryStatus[clientGroup.client_id]" class="spinner-border spinner-border-sm"></span>
                <i v-else class="icon-checkmark"></i>
              </button>
              <span v-if="clientGroup.judicial_recovery_date_formatted" class="text-muted small ml-2">
                {{ clientGroup.judicial_recovery_date_formatted }}
              </span>
              <span
                v-if="clientGroup.ruby_workflow_status === 'blocked'"
                class="badge ml-3"
                :class="isStaleRubyBlock(clientGroup) ? 'badge-danger' : 'badge-warning'"
                :title="rubyErrorTitle(clientGroup)"
              >
                {{ $t('lang.ruby_payeur.badge_blocked', { label: rubyBlockLabel(clientGroup) }) }}
                <span v-if="isStaleRubyBlock(clientGroup)">
                  {{ $t('lang.ruby_payeur.badge_blocked_since', { hours: rubyBlockedHours(clientGroup) }) }}
                </span>
              </span>
              <span
                v-if="clientGroup.ruby_workflow_status === 'pending_creation'"
                class="badge badge-success ml-3"
              >
                {{ $t('lang.ruby_payeur.creation_in_progress') }}
              </span>
              <span
                v-if="clientGroup.ruby_workflow_status === 'cancelled' && clientGroup.ruby_error_code && !clientGroup.ruby_ref"
                class="badge badge-danger ml-3"
                :title="rubyErrorTitle(clientGroup)"
              >
                {{ $t('lang.ruby_payeur.badge_not_sent', { label: rubyBlockLabel(clientGroup) }) }}
              </span>
              <span
                v-if="clientGroup.ruby_ref"
                class="text-muted small ml-3"
              >
                Ruby {{ clientGroup.ruby_ref }}
                <span v-if="clientGroup.ruby_status"> · {{ clientGroup.ruby_status }}</span>
                <span v-if="clientGroup.ruby_workflow_status === 'closed'"> · Clôturé</span>
              </span>
            </div>
            <div class="text-right">
              <div class="mb-1">
                <strong>Resultat: {{ clientGroup.totalCount }}</strong>
              </div>
              <div class="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  class="btn btn-link p-0 border-0 align-middle mr-3"
                  :class="{ 'comment-icon-warning': clientGroup.time_warning == '1' || clientGroup.time_warning === 1 }"
                  @click="openRecoveryNotes(clientGroup)"
                >
                  <img src="@/assets/images/comment.png" alt="comment" width="18" height="18" />
                </button>
                <strong>Montant: € {{ clientGroup.totalAmount }}</strong>
              </div>
              <div
                v-if="clientGroup.ruby_ref"
                class="text-muted small mt-1"
              >
                Recouvré: € {{ formatRubyRecovered(clientGroup.ruby_amount_recovered) }}
              </div>
            </div>
          </div>

          <!-- Tabs Navigation -->
          <div class="card-tabs-nav">
            <a
              class="card-tab"
              :class="{ active: getActiveTab(clientGroup.client_id) === 'invoices' }"
              href="#"
              @click.prevent="switchTab(clientGroup.client_id, 'invoices')"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;margin-right:5px"><path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z"/><path d="M9 9h1M9 13h6M9 17h6"/></svg>
              Invoices
            </a>
            <a
              class="card-tab"
              :class="{ active: getActiveTab(clientGroup.client_id) === 'recovery_actions' }"
              href="#"
              @click.prevent="switchTab(clientGroup.client_id, 'recovery_actions')"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align:-2px;margin-right:5px"><path d="M12 8v4l3 3"/><circle cx="12" cy="12" r="9"/></svg>
              Recovery Actions
              <span class="tab-badge">{{ filteredRecoveryActions(clientGroup).length }}</span>
            </a>
          </div>

          <!-- Tab 1: Invoices (existing table, untouched) -->
          <div class="card-body p-2 invoice-table-container" v-show="getActiveTab(clientGroup.client_id) === 'invoices'">
            <div class="table table-responsive">
              <Table
                class="mx-2 w-100"
                :headers="headers"
                :cols="cols"
                :data="clientGroup.invoices"
                :checkbox="false"
                :notselect="true"
                :model="model"
                :fieldsLoading="fieldsLoading"
                :key="`client-${clientGroup.client_id}`"
                @editComment="editComment"
                @editInvoiceStatus="editInvoiceStatus"
                @openClient="openClient"
                @pdfDownload="pdfDownload($event)"
                @changePaymentStatus="changePaymentStatus"
                >
              </Table>
            </div>
          </div>

          <!-- Tab 2: Recovery Actions -->
          <div class="recovery-tab-body" v-show="getActiveTab(clientGroup.client_id) === 'recovery_actions'">
            <div v-if="loadingRecoveryActions[clientGroup.client_id]" class="text-center py-4">
              <span class="spinner-border spinner-border-sm"></span>
            </div>
            <div v-else>
              <div class="recovery-tab-footer" style="border-top:none; border-bottom: 0.5px solid rgba(0,0,0,0.12); margin-bottom:4px; margin-top:0; padding-top:12px;">
                <button
                  class="btn-followup-action"
                  :disabled="followingUp[clientGroup.client_id]"
                  @click="followUpThibault(clientGroup)"
                >
                  <span v-if="followingUp[clientGroup.client_id]" class="spinner-border spinner-border-sm mr-1"></span>
                  <svg v-else width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:6px;vertical-align:-2px"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>
                  Follow-up Thibault
                </button>
              </div>
              <table class="recovery-table">
                <thead>
                  <tr>
                    <th>Type d'action</th>
                    <th>Date d'envoi</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="action in filteredRecoveryActions(clientGroup)"
                    :key="action.id"
                  >
                    <td>
                      <span v-if="action.action_type === 'follow_up_thibault'" class="action-badge action-badge--followup">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></svg>
                        {{ action.action_label }}
                      </span>
                      <span v-else class="action-badge action-badge--email">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 7l9 6 9-6"/><rect x="3" y="5" width="18" height="14" rx="2"/></svg>
                        {{ action.action_label }}
                      </span>
                    </td>
                    <td class="action-date">{{ formatActionDate(action.triggered_at) }}</td>
                  </tr>
                  <tr v-if="!filteredRecoveryActions(clientGroup).length">
                    <td colspan="2" class="text-center text-muted py-3">No actions yet</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Comments
      modal-name="recovery-notes-modal"
      :client="selectedClientForNotes"
      :notes="recoveryNotes"
      :visible="recoveryNotesModalVisible"
      :loading="recoveryNotesLoading"
      @publish="publishRecoveryNote"
      @close="recoveryNotesModalVisible = false"
    />

    <Modal name="edit-invoice-status-modal" size="35%" :close="true">
      <div class="p-4">
        <h4>Status facture</h4>
        <select
          class="form-control w-50"
          v-model="editingInvoicePaymentStatus"
          :disabled="savingInvoiceStatus"
        >
          <option disabled value="">Sélectionner un statut</option>
          <option value="1">Nouvel Impayé</option>
          <option value="3">Ruby payeur</option>
        </select>
        <div class="float-right pb-3 mt-4">
          <button class="btn btn-secondary mx-1" @click="closeInvoiceStatusModal">
            {{ $t('lang.button.cancel') }}
          </button>
          <button
            class="btn btn-primary themed-button ml-1"
            :disabled="savingInvoiceStatus || !editingInvoicePaymentStatus"
            @click="saveInvoiceStatus"
          >
            <span v-if="savingInvoiceStatus" class="spinner-border spinner-border-sm mr-2"></span>
            {{ $t('lang.button.save') }}
          </button>
        </div>
      </div>
    </Modal>

    <!-- Modal para editar comentario -->
    <Modal name="edit-comment-modal" size="50%" :close="true">
      <div class="p-4">
        <h4>{{ $t("lang.column.status") }}</h4>
        <select
          class="form-control w-25"
          v-model="judicialRecovery"
        >
          <option value=0>Non débuté</option>
          <option value=2>Amiable (attente de réponse)</option>
          <option value=5>Amiable (OK paiement intégralité)</option>
          <option value=6>Amiable (OK paiement partiel + avoir)</option>
          <option value=7>Refus de payer</option>
          <option value=1>Judiciaire (ruby)</option>
          <option value=3>Injonction en cours (ruby)</option>
          <option value=4>Saisie attribution (ruby)</option>
          <option value=8>Recouvré (ruby)</option>
          <option value=9>Clôturé (ruby)</option>
        </select>
        <h4 class="mt-3">Edit Comment</h4>
        <form>
          <div class="form-group">
            <label for="comment-textarea">Comment:</label>
            <textarea
              id="comment-textarea"
              class="form-control mt-3"
              rows="5"
              v-model="editingComment"
              :placeholder="$t('lang.label.comment')"
              maxlength="2000"
            ></textarea>
          </div>
        </form>
        <div class="float-right pb-3">
          <button
            class="btn btn-secondary mx-1"
            @click="closeEditModal"
          >
            {{ $t('lang.button.cancel') }}
          </button>
          <button
            class="btn btn-primary themed-button ml-1"
            :disabled="savingComment || !canSaveComment"
            @click="saveComment"
          >
            <span v-if="savingComment" class="spinner-border spinner-border-sm mr-2"></span>
            {{ $t('lang.button.save') }}
          </button>
        </div>
      </div>
    </Modal>
  </main>
  </section>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { billingsService, usersService } from "@/_services";
import { statusBadgeMixin } from "@/_mixins/";
import { authHeader } from "@/_helpers";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import Modal from "@/components/Common/Modal.vue";
import Comments from "@/components/Common/Comments.vue";
import Tabs from "@/components/Common/Tabs.vue";
//import IndustrySearch from "@/components/Common/IndustrySearch.vue";
import IndustrySearch from "../AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "InvoiceRecovering",
  data() {
    return {
      loading: true,
      fieldsLoading: true,
      savingComment: false,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      invoices: [],
      filterSearch: {
        account_manager_id: null,
      },
      total: 0,
      apiTotalAmount: 0,
      totalInvoices: 0,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      filters: [],
      lastFilters: [],
      selectedRecoveryFolderStatus: -1,
      recoveryFolderTabDefinitions: {
        all: { id: -1, label: 'Tout' },
        notStarted: { id: 0, label: 'Non débuté' },
        amicableWaiting: { id: 2, label: 'Amiable (attente de réponse)' },
        amicableFullPayment: { id: 5, label: 'Amiable (OK paiement intégralité)' },
        amicablePartialPayment: { id: 6, label: 'Amiable (OK paiement partiel + avoir)' },
        refused: { id: 7, label: 'Refus de payer' },
        judicial: { id: 1, label: 'Judiciaire (ruby)' },
        injunction: { id: 3, label: 'Injonction en cours (ruby)' },
        seizure: { id: 4, label: 'Saisie attribution (ruby)' },
        recovered: { id: 8, label: 'Recouvré (ruby)' },
        closedRuby: { id: 9, label: 'Clôturé (ruby)' },
      },
      judicialRecovery: null,
      editingInvoiceId: null,
      editingComment: "",
      editingInvoiceStatusId: null,
      editingInvoicePaymentStatus: null,
      savingInvoiceStatus: false,
      // Recovery actions state (keyed by client_id)
      activeTab: {},
      recoveryActions: {},
      loadingRecoveryActions: {},
      followingUp: {},
      editingRecoveryStatus: {},
      recoveryStatusDraft: {},
      savingRecoveryStatus: {},
      selectedClientForNotes: null,
      recoveryNotes: [],
      recoveryNotesModalVisible: false,
      recoveryNotesLoading: false,
      rubyBlockedAlertHours: 2,
      userOliverSales: [{ id: "0", label: "Select option..."}, { id: "all", label: "All"}],
      userOliverSale: ['0'],
      oliverSalesLoaded: false,
      cols: [
        [
          {
            value: "date",
            format: "date",
            type: "date",
          },
        ],
        [
          {
            value: "recovery_invoice_status_display_id",
            type: "itemBadge",
            emit: "editInvoiceStatus",
            colors: [
              { id: "1", label: "Nouvel Impayé", bgColor: "#E67E22", textColor: "#FFFFFF" },
              { id: "3", label: "Ruby payeur", bgColor: "#27AE60", textColor: "#FFFFFF" },
              { id: "payment_processing", label: "Paiement en cours", bgColor: "#6C757D", textColor: "#FFFFFF" },
            ],
          }
        ],
        [
          {
            value: "id",
          },
        {
            fromRecovering: 1,
            btnId: "id",
            emit: "pdfDownload",
            format: 3,
            type: "invoiceFormats",
          },
        ],
        [
          {
            value: "payment_method_type",
            type: "itemBadge",
            colors: [
              {
                id: "sepa",
                label: "SEPA",
                bgColor: "blue",
                textColor: "#FFFFFF",
              },
              {
                id: "credit_card",
                label: "Credit Card",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "bank_transfer",
                label: "Bank Transfer",
                bgColor: "yellow",
                textColor: "#000000",
              },
            ],
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "cpi_category",
            value2: "cpi_score_formatted",
            type: "itemBadge",
            class: "badge badge-pill text-small",
            colors: [
              { id: "Strategic", label: "Strategic", bgColor: "#28a745", textColor: "#FFFFFF" },
              { id: "Core", label: "Core", bgColor: "#007bff", textColor: "#FFFFFF" },
              { id: "Watch", label: "Watch", bgColor: "#fd7e14", textColor: "#FFFFFF" },
              { id: "Low Priority", label: "Low Priority", bgColor: "#6c757d", textColor: "#FFFFFF" },
              { id: "Launching", label: "Launching", bgColor: "#6f42c1", textColor: "#FFFFFF" },
              { id: "-", label: "-", bgColor: "#e9ecef", textColor: "#6c757d" },
            ],
          },
        ],
        [
          {
            value: "account_manager",
          },
        ],
        [
          {
            value: "amount_with_vat",
            format: "money",
            simbol: "€"
          },
        ],
        [
          {
            btnId: "id",
            value1: "payment_status_id",
            value2: "has_payment_method",
            emit: "changePaymentStatus",
            format: 4,
            collectOnly: true,
            type: "invoiceFormats",
          },
        ],
      ],
      headers: [
        {
          label: "Invoice Date",
          percentage: "12%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: "Invoice Status",
          percentage: "12%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t("lang.column.invoicenumber"),
          percentage: "10%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: this.$t("lang.column.paymentmethod"),
          percentage: "12%",
          class: "overflowhide",
          id: 3,
        },
        {
          label: this.$t("lang.label.client"),
          percentage: "15%",
          class: "overflowhide",
          id: 4,
        },
        {
          label: "CPI",
          percentage: "12%",
          class: "overflowhide",
          id: 9,
        },
        {
          label: "Account Manager",
          percentage: "15%",
          class: "overflowhide",
          id: 5,
        },
        {
          label: this.$t("lang.column.amount"),
          percentage: "12%",
          class: "overflowhide",
          id: 6,
        },
        {
          label: "Collect",
          percentage: "8%",
          class: "overflowhide",
          id: 7,
        },
      ],
    };
  },
  components: {
    LoadingSpinner,
    Pagination,
    Table,
    Modal,
    Comments,
    Tabs,
    IndustrySearch,
  },
  mixins: [statusBadgeMixin],
  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
    }),

    totalPageInvoices() {
      return this.invoices.length;
    },

    canSaveComment() {
      return this.editingComment && this.editingComment.trim().length > 0;
    },

    isAccountManager() {
      return this.currentUser.role_id == 1 && this.currentUser.user_constraint_id == 2;
    },

    groupedInvoicesByClient() {
      const grouped = {};
      this.invoices.forEach((invoice) => {
        const clientId = invoice.client_id;
        if (!grouped[clientId]) {
          grouped[clientId] = {
            client_id: clientId,
            client_name: invoice.client_name,
            invoices: [],
            totalAmount: 0,
            totalCount: 0,
            active_licenses_by_client: invoice.active_licenses_by_client || 0,
            payment_declined_days: invoice.payment_declined_days || 0,
            client_status: invoice.client_status,
            judicial_recovery_status_id: invoice.judicial_recovery_status_id || 0,
            judicial_recovery_status: invoice.judicial_recovery_status || 'Non débuté',
            judicial_recovery_date: invoice.judicial_recovery_date || null,
            judicial_recovery_date_formatted: invoice.judicial_recovery_date_formatted || '',
            ruby_ref: invoice.ruby_ref || '',
            ruby_status: invoice.ruby_status || '',
            ruby_amount_recovered: invoice.ruby_amount_recovered || null,
            ruby_workflow_status: invoice.ruby_workflow_status || '',
            ruby_error_code: invoice.ruby_error_code || '',
            ruby_error_message: invoice.ruby_error_message || '',
            ruby_updated_at: invoice.ruby_updated_at || '',
            time_warning: invoice.time_warning,
          };
        }
        grouped[clientId].invoices.push(invoice);
        grouped[clientId].totalAmount += parseFloat(invoice.amount_with_vat || 0);
        grouped[clientId].totalCount += 1;
        if (invoice.active_licenses_by_client !== undefined && invoice.active_licenses_by_client !== null) {
          grouped[clientId].active_licenses_by_client = invoice.active_licenses_by_client;
        }
        if (invoice.payment_declined_days !== undefined && invoice.payment_declined_days !== null) {
          grouped[clientId].payment_declined_days = invoice.payment_declined_days;
        }
        if (invoice.judicial_recovery_date && (!grouped[clientId].judicial_recovery_date || new Date(invoice.judicial_recovery_date) > new Date(grouped[clientId].judicial_recovery_date))) {
          grouped[clientId].judicial_recovery_status_id = invoice.judicial_recovery_status_id || 0;
          grouped[clientId].judicial_recovery_status = invoice.judicial_recovery_status || 'Non débuté';
          grouped[clientId].judicial_recovery_date = invoice.judicial_recovery_date;
          grouped[clientId].judicial_recovery_date_formatted = invoice.judicial_recovery_date_formatted || '';
        }
        if (invoice.ruby_ref) {
          grouped[clientId].ruby_ref = invoice.ruby_ref;
          grouped[clientId].ruby_status = invoice.ruby_status || '';
          grouped[clientId].ruby_amount_recovered = invoice.ruby_amount_recovered || null;
        }
        if (invoice.ruby_workflow_status) {
          grouped[clientId].ruby_workflow_status = invoice.ruby_workflow_status;
          grouped[clientId].ruby_error_code = invoice.ruby_error_code || '';
          grouped[clientId].ruby_error_message = invoice.ruby_error_message || '';
          grouped[clientId].ruby_updated_at = invoice.ruby_updated_at || grouped[clientId].ruby_updated_at;
        }
      });

      // Convert to array and format totalAmount
      const array = Object.values(grouped).map((group) => ({
        ...group,
        totalAmount: group.totalAmount.toFixed(2),
      }));

      // payment_declined_days del mayor al menor
      array.sort((a, b) => (b.payment_declined_days || 0) - (a.payment_declined_days || 0));

      return [...array];
    },

    filteredGroupedInvoicesByClient() {
      if (this.selectedRecoveryFolderStatus === -1) {
        return this.groupedInvoicesByClient;
      }

      return this.groupedInvoicesByClient.filter(
        (group) => Number(group.judicial_recovery_status_id || 0) === Number(this.selectedRecoveryFolderStatus)
      );
    },

    recoveryFolderTabs() {
      return Object.keys(this.recoveryFolderTabDefinitions).reduce((tabs, key) => {
        const tab = this.recoveryFolderTabDefinitions[key];
        const count = tab.id === -1
          ? this.groupedInvoicesByClient.length
          : this.groupedInvoicesByClient.filter(
            (group) => Number(group.judicial_recovery_status_id || 0) === Number(tab.id)
          ).length;

        tabs[key] = {
          id: tab.id,
          name: `${tab.label} (${count})`,
        };

        return tabs;
      }, {});
    },

    totalClients() {
      return this.groupedInvoicesByClient.length;
    },

    totalRecovering() {
      return this.groupedInvoicesByClient.filter(
        (g) => g.client_status === 'Recovery'
      ).length;
    },

    totalPaymentDeclined() {
      return this.groupedInvoicesByClient.filter(
        (g) => g.client_status === 'Pending deleted'
      ).length;
    },

    totalAmount() {
      const sum = this.groupedInvoicesByClient.reduce(
        (acc, g) => acc + parseFloat(g.totalAmount || 0),
        0
      );
      return sum.toFixed(2);
    },

    staleBlockedRubyClients() {
      return this.groupedInvoicesByClient.filter((group) => this.isStaleRubyBlock(group));
    },
  },
  created() {
    this.loadAccountManagers();
    this.getData();
  },
  mounted(){
    this.setHeader();
  },
  methods: {
    ...mapActions("headertopbar", {
         setCurrentRoute:"setRoute",
         setCurrentRouteChild:"setRouteChild"
    }),
    setHeader(){
      this.setCurrentRoute({ page: "invoices_recovering", label: "Invoices Recovering" });
      this.setCurrentRouteChild({ child: "" });
    },
    changeRecoveryFolderTab(statusId) {
      this.selectedRecoveryFolderStatus = statusId;
    },
    loadAccountManagers() {
      usersService
        .getUserOliverSales()
        .then((data) => {
          this.userOliverSales = data.result.map((user) => ({
            id: user.id,
            label: `${user.name} ${user.lastname}`,
          }));

          this.userOliverSales.unshift({ id: "0", label: "Select option..."});

          if(this.isAccountManager) {
            this.userOliverSale = [this.currentUser.id.toString()];
            this.filterSearch.account_manager_id = this.currentUser.id;
          }

          this.oliverSalesLoaded = true;
        })
        .catch((error) => {
          console.error("Error loading account managers:", error);
          this.oliverSalesLoaded = true;
        });
    },
    selectOliverSale(selected) {
      if (selected.id != 0) {
        this.filterSearch.account_manager_id = selected.id;
      } else {
        this.userOliverSale = ['0'];
        this.filterSearch.account_manager_id = null;
      }
      this.loadInvoices();
    },
    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },
    pdfDownload(id){
      billingsService.downloadInvoice(id).then(({ blob, filename }) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename || `invoice-${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      });
    },
    changePaymentStatus(paymentId, paymentStatusId) {
      if (Number(paymentStatusId) !== 2) return;
      billingsService
        .changePaymentStatus(paymentId, paymentStatusId)
        .then(() => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            showConfirmButton: false,
            timer: 2500,
          });
          this.loadInvoices();
        })
        .catch((err) => {
          const blocked = err && (err.error === "card_not_chargeable" || Number(err.status) === 409);
          const declined = Number(err && err.status) === 402 || /Payment Declined/i.test(String((err && err.message) || err || ""));
          if (blocked) {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.error"),
              text: (err && err.message) || "Cette facture ne peut pas être prélevée.",
              showConfirmButton: true,
            });
          } else if (declined) {
            this.$swal({
              type: "error",
              title: "Error",
              text: this.$t("lang.general.error_402"),
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.error"),
              html: this.$t("lang.general.error"),
              showConfirmButton: true,
            });
          }
        });
    },
    editComment(invoiceId) {
      const invoice = this.invoices.find((inv) => inv.id === invoiceId);
      if (invoice) {
        this.editingInvoiceId = invoiceId;
        this.editingComment = invoice.comment || "";
        this.judicialRecovery = invoice.judicial_recovery_status_id;
        this.$modal.show("edit-comment-modal");
      }
    },
    editInvoiceStatus(invoiceId) {
      const invoice = this.invoices.find((inv) => String(inv.id) === String(invoiceId));
      if (!invoice) return;
      if (this.isPaymentProcessing(invoice)) {
        this.$swal({
          type: 'info',
          title: 'Paiement en cours',
          text: 'Le statut de recouvrement ne peut pas être modifié tant que le paiement est en cours.',
        });
        return;
      }
      this.editingInvoiceStatusId = invoiceId;
      const recoveryInvoiceStatusId = invoice.recovery_invoice_status_id;
      this.editingInvoicePaymentStatus = recoveryInvoiceStatusId === null || recoveryInvoiceStatusId === undefined || recoveryInvoiceStatusId === ''
        ? ''
        : String(recoveryInvoiceStatusId);
      this.$modal.show("edit-invoice-status-modal");
    },
    isPaymentProcessing(invoice) {
      return invoice.is_payment_processing === true
        || invoice.is_payment_processing === 1
        || invoice.is_payment_processing === '1'
        || Number(invoice.payment_status_id) === 7;
    },
    closeInvoiceStatusModal() {
      this.$modal.hide("edit-invoice-status-modal");
      this.editingInvoiceStatusId = null;
      this.editingInvoicePaymentStatus = null;
    },
    saveInvoiceStatus() {
      if (!this.editingInvoiceStatusId || !this.editingInvoicePaymentStatus) return;
      const recoveryInvoiceStatusId = Number(this.editingInvoicePaymentStatus);
      this.savingInvoiceStatus = true;

      billingsService.updateRecoveryInvoiceStatus(this.editingInvoiceStatusId, recoveryInvoiceStatusId)
        .then(() => {
          const statusLabel = this.getInvoicePaymentStatusLabel(recoveryInvoiceStatusId);
          this.invoices = this.invoices.map((invoice) => {
            if (String(invoice.id) !== String(this.editingInvoiceStatusId)) return invoice;
            return {
              ...invoice,
              recovery_invoice_status_id: recoveryInvoiceStatusId,
              recovery_invoice_status: statusLabel,
              recovery_invoice_status_display_id: recoveryInvoiceStatusId,
              recovery_invoice_status_date: new Date().toISOString(),
            };
          });
          const invoice = this.invoices.find((item) => String(item.id) === String(this.editingInvoiceStatusId));
          if (invoice) {
            this.loadRecoveryActionsForClient(invoice.client_id);
          }
          this.closeInvoiceStatusModal();
        })
        .catch((error) => {
          console.error('Error saving invoice status:', error);
          this.$swal({
            type: 'error',
            title: 'Erreur',
            text: 'Impossible de sauvegarder le status facture.',
          });
        })
        .finally(() => {
          this.savingInvoiceStatus = false;
        });
    },
    getInvoicePaymentStatusLabel(statusId) {
      const labels = {
        1: 'Nouvel Impayé',
        3: 'Ruby payeur',
      };
      return labels[Number(statusId)] || 'Nouvel Impayé';
    },
    closeEditModal() {
      this.$modal.hide("edit-comment-modal");
      this.editingInvoiceId = null;
      this.editingComment = "";
    },
    saveComment() {
      if (!this.editingInvoiceId) return;

      this.savingComment = true;
      let numberJudicialRecovery = Number(this.judicialRecovery);
      const payload = {
        id: this.editingInvoiceId,
        comment: this.editingComment,
        judicial_recovery: numberJudicialRecovery
      };

      billingsService.updateComment(payload)
      .then(() => {
        // Update the invoice in the list
        const invoice = this.invoices.find((inv) => inv.id === this.editingInvoiceId);
        if (invoice) {
          invoice.comment = this.editingComment;
        }
        this.$swal({
          type: "success",
          title: this.$t("lang.label.great"),
          text: this.$t("lang.label.yourdatawassuccessfullychanged"),
          showConfirmButton: false,
          timer: 2500,
        });
        this.closeEditModal();
        this.savingComment = false;
      })
      .catch((error) => {
        console.error("Error saving comment:", error);
        alert("Error saving comment. Please try again.");
        this.savingComment = false;
      })
      .finally(() => {
        window.location.reload();
        this.savingComment = false;
      });

      this.savingComment = true;
    },
    saveRecoveryStatus(clientGroup, statusId) {
      const clientId = clientGroup.client_id;
      const previousStatusId = clientGroup.judicial_recovery_status_id;
      const numberJudicialRecovery = Number(statusId);
      this.$set(this.savingRecoveryStatus, clientId, true);

      billingsService.updateRecoveryStatus({
        client_id: clientId,
        judicial_recovery: numberJudicialRecovery,
      })
        .then((response) => {
          const statusLabel = this.getJudicialRecoveryStatusLabel(numberJudicialRecovery);
          const formattedDate = moment().format('DD/MM/YYYY');
          this.invoices = this.invoices.map((invoice) => {
            if (String(invoice.client_id) !== String(clientId)) return invoice;
            return {
              ...invoice,
              judicial_recovery_status_id: numberJudicialRecovery,
              judicial_recovery_status: statusLabel,
              judicial_recovery_date: new Date().toISOString(),
              judicial_recovery_date_formatted: formattedDate,
            };
          });
          this.$set(this.editingRecoveryStatus, clientId, false);
          this.loadRecoveryActionsForClient(clientId);
          this.getInvoices();
          this.showRubyPayeurFeedback(response && response.ruby_payeur);
        })
        .catch((error) => {
          console.error('Error saving recovery status:', error);
          clientGroup.judicial_recovery_status_id = previousStatusId;
          this.$swal({
            type: 'error',
            title: 'Erreur',
            text: 'Impossible de sauvegarder le status recovery.',
          });
        })
        .finally(() => {
          this.$set(this.savingRecoveryStatus, clientId, false);
        });
    },
    editRecoveryStatus(clientId) {
      const invoice = this.invoices.find((item) => String(item.client_id) === String(clientId));
      this.$set(this.recoveryStatusDraft, clientId, invoice ? String(invoice.judicial_recovery_status_id || 0) : '0');
      this.$set(this.editingRecoveryStatus, clientId, true);
    },
    getJudicialRecoveryStatusLabel(statusId) {
      const labels = {
        0: 'Non débuté',
        1: 'Judiciaire (ruby)',
        2: 'Amiable (attente de réponse)',
        3: 'Injonction en cours (ruby)',
        4: 'Saisie attribution (ruby)',
        5: 'Amiable (OK paiement intégralité)',
        6: 'Amiable (OK paiement partiel + avoir)',
        7: 'Refus de payer',
        8: 'Recouvré (ruby)',
        9: 'Clôturé (ruby)',
      };
      return labels[Number(statusId)] || 'Non débuté';
    },
    openRecoveryNotes(clientGroup) {
      this.selectedClientForNotes = { ...clientGroup, client_name: clientGroup.client_name };
      this.recoveryNotes = [];
      this.recoveryNotesModalVisible = true;
      this.recoveryNotesLoading = true;
      billingsService.getRecoveryNotes(clientGroup.client_id)
        .then((res) => {
          this.recoveryNotes = Array.isArray(res) ? res : (Array.isArray(res && res.result) ? res.result : []);
        })
        .catch(() => {
          this.recoveryNotes = [];
        })
        .finally(() => {
          this.recoveryNotesLoading = false;
        });
    },
    publishRecoveryNote(message) {
      if (!this.selectedClientForNotes || !(message || '').trim()) return;
      const clientId = this.selectedClientForNotes.client_id;
      billingsService.createRecoveryNote(clientId, (message || '').trim())
        .then(() => {
          this.invoices = this.invoices.map((invoice) => {
            if (String(invoice.client_id) !== String(clientId)) return invoice;
            return { ...invoice, time_warning: '0' };
          });
          return billingsService.getRecoveryNotes(clientId);
        })
        .then((res) => {
          this.recoveryNotes = Array.isArray(res) ? res : (Array.isArray(res && res.result) ? res.result : []);
        })
        .catch((err) => {
          console.error('Error saving recovery note:', err);
        });
    },
    getData() {
      this.getInvoices();
    },
    loadInvoices() {
      this.pagination.cantPerPage = 25;
      this.pagination.currentPage = 1;
      this.getInvoices();
      // this.getTotalInvoices();
    },
    getInvoices() {
      // if (this.filters != this.lastFilters) {
      //   this.getTotalInvoices();
      // }
      this.loading = true;
      this.totalInvoices = 0;
      this.filters.cantPerPage = this.pagination.cantPerPage;
      this.filters.currentPage = this.pagination.currentPage;

      // Payment status ID for "Recovery" (Recovering)
      const paymentStatusId = 6;
      const onlyViewRecovering = true;

      if(this.isAccountManager) {
        this.userOliverSale = [this.currentUser.id.toString()];
        this.filterSearch.account_manager_id = this.currentUser.id;
      }

      billingsService
        .getInvoices(
          this.pagination.cantPerPage,
          this.pagination.currentPage,
          paymentStatusId,
          this.totalInvoices,
          this.filterSearch,
          onlyViewRecovering
        )
        .then((result) => {
          this.invoices = result.list || [];

          // Pre-load recovery action counts for all visible clients
          const clientIds = [...new Set(this.invoices.map((inv) => inv.client_id))];
          clientIds.forEach((clientId) => this.loadRecoveryActionsForClient(clientId));

          this.invoices.forEach((item) => {
            item.montat_per_invoice = ((item.amount - (item.discount_amount || 0) - (item.discount_previous_payment || 0)) * 1).toFixed(2);
            item.vats_per_invoice = ((item.amount_with_vat - item.amount - (item.discount_amount || 0)) * 1).toFixed(2);

            // Account manager comes as string from API, ensure it's set
            if (!item.account_manager) {
              item.account_manager = '-';
            }

            // Ensure comment field exists (may not be in API response yet)
            if (!item.comment) {
              item.comment = '';
            }

            const hasExplicitRecoveryInvoiceStatus = [1, 3]
              .includes(Number(item.recovery_invoice_status_id));
            const isPaymentProcessing = this.isPaymentProcessing(item);

            if (!hasExplicitRecoveryInvoiceStatus && !isPaymentProcessing) {
              const fallbackStatuses = { 3: 1, 6: 1 };
              item.recovery_invoice_status_id = fallbackStatuses[Number(item.payment_status_id)] || 1;
            }

            if (isPaymentProcessing) {
              item.recovery_invoice_status_display_id = 'payment_processing';
            } else {
              if (!item.recovery_invoice_status) {
                item.recovery_invoice_status = this.getInvoicePaymentStatusLabel(item.recovery_invoice_status_id);
              }
              item.recovery_invoice_status_display_id = item.recovery_invoice_status_id;
            }

            // CPI: normalize category for itemBadge and format score for "(0.82)" display
            const category = item.cpi_category || (item.cpi_score != null ? this.cpiCategoryFromScore(Number(item.cpi_score)) : null);
            item.cpi_category = category || '-';
            item.cpi_score_formatted = item.cpi_score != null ? Number(item.cpi_score).toFixed(2) : '';

            // Judicial recovery: formatear la fecha del cambio de estado
            item.judicial_recovery_date_formatted = item.judicial_recovery_date
              ? moment(item.judicial_recovery_date).format('DD/MM/YYYY')
              : '';
          });
        })
        .then((result) => {
          this.lastFilters = this.filters;
          this.loading = false;
          this.fieldsLoading = false;
        })
        .catch((error) => {
          console.error("Error loading invoices:", error);
          this.loading = false;
          this.fieldsLoading = false;
        });
    },

    getTotalInvoices() {
      this.totalInvoices = 1;
      this.filters.cantPerPage = this.pagination.cantPerPage;
      this.filters.currentPage = this.pagination.currentPage;

      const paymentStatusId = 6; // Payment status ID for "Recovery" (Recovering)
      const onlyViewRecovering = true;

      if(this.isAccountManager) {
            this.userOliverSale = [this.currentUser.id.toString()];
            this.filterSearch.account_manager_id = this.currentUser.id;
      }

      billingsService
        .getInvoices(
          this.pagination.cantPerPage,
          this.pagination.currentPage,
          paymentStatusId,
          this.totalInvoices,
          this.filterSearch,
          onlyViewRecovering
        )
        .then((result) => {
          this.total = result.total || 0;
          this.apiTotalAmount = result.total_amount || 0;
          if (this.apiTotalAmount == null) this.apiTotalAmount = 0;
        })
        .catch((error) => {
          console.error("Error loading total invoices:", error);
        });
    },

    getClientInfoPlaceholder(licenses, days) {
      // Manejar valores undefined/null y usar valores por defecto
      const daysValue = days !== undefined && days !== null ? days : 0;
      const licensesValue = licenses !== undefined && licenses !== null ? licenses : 0;
      return daysValue + " days - " + licensesValue + " active email licenses";
    },

    formatRubyRecovered(amount) {
      const value = Number(amount);
      return Number.isFinite(value) ? value.toFixed(2) : '0.00';
    },

    rubyErrorLabel(code) {
      const labelKeys = {
        missing_siren: 'error_missing_siren_or_foreign',
        siren_not_found: 'error_missing_siren_or_foreign',
        foreign_vat: 'error_missing_siren_or_foreign',
        ambiguous_siren: 'error_ambiguous_siren',
        missing_contact: 'error_missing_contact',
        missing_invoice_fields: 'error_missing_invoice_fields',
        missing_billing_proof: 'error_missing_billing_proof',
        snapshot_too_large: 'error_snapshot_too_large',
        provider_http: 'error_provider_http',
      };
      if (labelKeys[code]) return this.$t(`lang.ruby_payeur.${labelKeys[code]}`);
      return code ? String(code).replace(/_/g, ' ') : this.$t('lang.ruby_payeur.error_not_sent');
    },

    isRubySirenError(code) {
      return ['missing_siren', 'siren_not_found', 'foreign_vat'].includes(code);
    },

    rubyErrorDetail(code) {
      const label = this.rubyErrorLabel(code);
      if (!this.isRubySirenError(code)) return label;
      return this.$t('lang.ruby_payeur.foreign_manual_handling', { label });
    },

    rubyBlockLabel(clientGroup) {
      return this.rubyErrorLabel(clientGroup && clientGroup.ruby_error_code);
    },

    rubyErrorTitle(clientGroup) {
      if (!clientGroup) return '';
      return [
        this.isRubySirenError(clientGroup.ruby_error_code) ? this.rubyErrorDetail(clientGroup.ruby_error_code) : '',
        clientGroup.ruby_error_message,
      ].filter(Boolean).join(' — ');
    },

    rubyPayeurFeedback(rubyPayeur) {
      const skipKeys = {
        no_unpaid_invoices: 'skip_no_unpaid_invoices',
        payments_already_linked: 'skip_payments_already_linked',
        missing_invoice_fields: 'error_missing_invoice_fields',
        client_not_found: 'skip_client_not_found',
        disabled: 'skip_disabled',
      };
      const outcome = rubyPayeur.outcome;
      const workflowStatus = rubyPayeur.workflow_status;
      const notCreatedTitle = this.$t('lang.ruby_payeur.not_created_title');

      if (outcome === 'queued') {
        return { type: 'success', title: this.$t('lang.ruby_payeur.creation_in_progress'), text: '' };
      }
      if (outcome === 'already_open' && ['pending_creation', 'submitted'].includes(workflowStatus)) {
        return {
          type: 'info',
          title: this.$t('lang.ruby_payeur.already_open_title'),
          text: this.$t('lang.ruby_payeur.already_open_text'),
        };
      }
      if (outcome === 'skipped') {
        const reason = rubyPayeur.reason;
        return {
          type: 'error',
          title: notCreatedTitle,
          text: skipKeys[reason] ? this.$t(`lang.ruby_payeur.${skipKeys[reason]}`) : reason || '',
        };
      }
      if (outcome === 'error') {
        return { type: 'error', title: notCreatedTitle, text: this.$t('lang.ruby_payeur.technical_error') };
      }
      return {
        type: 'error',
        title: outcome === 'blocked' || workflowStatus === 'blocked'
          ? this.$t('lang.ruby_payeur.blocked_title')
          : notCreatedTitle,
        text: this.rubyErrorDetail(rubyPayeur.error_code),
      };
    },

    showRubyPayeurFeedback(rubyPayeur) {
      if (!rubyPayeur || !rubyPayeur.outcome) return;
      const feedback = this.rubyPayeurFeedback(rubyPayeur);
      this.$swal({
        type: feedback.type,
        title: feedback.title,
        text: feedback.text,
        ...(feedback.type === 'success' ? { showConfirmButton: false, timer: 2500 } : {}),
      });
    },

    parisOffsetForDate(datePart) {
      try {
        const probe = new Date(`${datePart}T12:00:00Z`);
        const formatted = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Paris',
          timeZoneName: 'shortOffset',
        }).format(probe);
        const match = formatted.match(/GMT([+-])(\d{1,2})(?::?(\d{2}))?/i)
          || formatted.match(/UTC([+-])(\d{1,2})(?::?(\d{2}))?/i);
        if (!match) return '+01:00';
        const hh = String(match[2]).padStart(2, '0');
        return `${match[1]}${hh}:${match[3] || '00'}`;
      } catch (e) {
        return '+01:00';
      }
    },

    parseNaiveParisDateTime(value) {
      const raw = String(value || '').trim();
      if (!raw) return moment.invalid();
      if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(raw)) {
        return moment.parseZone(raw);
      }
      const match = raw.replace(' ', 'T').match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/);
      if (!match) return moment(raw);
      return moment.parseZone(`${match[1]}T${match[2]}${this.parisOffsetForDate(match[1])}`);
    },

    rubyBlockedHours(clientGroup) {
      if (!clientGroup || !clientGroup.ruby_updated_at) return 0;
      const updated = this.parseNaiveParisDateTime(clientGroup.ruby_updated_at);
      if (!updated.isValid()) return 0;
      return Math.max(0, moment().diff(updated, 'hours'));
    },

    isStaleRubyBlock(clientGroup) {
      return !!clientGroup
        && clientGroup.ruby_workflow_status === 'blocked'
        && this.rubyBlockedHours(clientGroup) >= this.rubyBlockedAlertHours;
    },

    cpiCategoryFromScore(score) {
      if (score >= 0.7) return 'Strategic';
      if (score >= 0.5) return 'Core';
      if (score >= 0.25) return 'Watch';
      return 'Low Priority';
    },

    getClientStatusPlaceHolder(status){
      switch(status){
        case 'Proposal':
          return 'badge badge-info';
        case 'Outdated':
          return 'badge badge-secondary';
        case 'Preparing':
          return 'badge badge-warning';
        case 'Active':
          return 'badge badge-success';
        case 'Standby':
          return 'badge badge-warning';
        case 'Deleted':
          return 'badge badge-danger';
        case 'Recovery':
          return 'badge badge-info';
        case 'Pending deleted':
          return 'badge badge-danger';
        case 'Validation':
          return 'badge badge-warning';
      }
    },

    // ── Tab helpers ────────────────────────────────────────────────────────────

    getActiveTab(clientId) {
      return this.activeTab[clientId] || 'invoices';
    },

    switchTab(clientId, tab) {
      this.$set(this.activeTab, clientId, tab);
      if (tab === 'recovery_actions' && !this.recoveryActions[clientId]) {
        this.loadRecoveryActionsForClient(clientId);
      }
    },

    loadRecoveryActionsForClient(clientId) {
      this.$set(this.loadingRecoveryActions, clientId, true);
      billingsService
        .getRecoveryActions(clientId)
        .then((data) => {
          this.$set(this.recoveryActions, clientId, Array.isArray(data) ? data : []);
        })
        .catch((err) => {
          console.error('Error loading recovery actions:', err);
          this.$set(this.recoveryActions, clientId, []);
        })
        .finally(() => {
          this.$set(this.loadingRecoveryActions, clientId, false);
        });
    },

    formatActionDate(dateStr) {
      if (!dateStr) return '';
      return moment(dateStr).format('DD/MM/YYYY HH:mm');
    },

    // ── Recovery Actions filtradas desde la factura más antigua ───────────────

    filteredRecoveryActions(clientGroup) {
      const actions = this.recoveryActions[clientGroup.client_id] || [];
      if (!clientGroup.invoices || !clientGroup.invoices.length) return actions;
      const minDate = clientGroup.invoices.reduce((min, inv) => {
        if (!inv.date) return min;
        const d = new Date(inv.date);
        return (!min || d < min) ? d : min;
      }, null);
      if (!minDate) return actions;
      return actions.filter(a => a.triggered_at && new Date(a.triggered_at) >= minDate);
    },

    // ── Follow-up Thibault ─────────────────────────────────────────────────────

    followUpThibault(clientGroup) {
      const clientId = clientGroup.client_id;
      this.$set(this.followingUp, clientId, true);

      const triggeredAt = new Date().toISOString();

      const invoicesPayload = clientGroup.invoices.map(inv => ({
        invoice_number: String(inv.id),
        due_date: inv.date ? moment(inv.date).format('YYYY-MM-DD') : '',
        amount_ttc: parseFloat(inv.amount_with_vat || 0),
      }));

      // Fecha de la factura más antigua (para filtrar conteos en el backend)
      const oldestInvoiceDate = clientGroup.invoices.reduce((min, inv) => {
        if (!inv.date) return min;
        const d = new Date(inv.date);
        return (!min || d < min) ? d : min;
      }, null);
      const oldestInvoiceDateStr = oldestInvoiceDate
        ? moment(oldestInvoiceDate).format('YYYY-MM-DD HH:mm:ss')
        : null;

      // counts are calculated server-side from the DB
      billingsService.createRecoveryAction({
        client_id:             clientId,
        action_type:           'follow_up_thibault',
        action_label:          'Follow-up Thibault',
        triggered_at:          triggeredAt,
        client_name:           clientGroup.client_name  || '',
        client_email:          clientGroup.client_email || '',
        total_unpaid_invoices: clientGroup.totalCount,
        invoices:              invoicesPayload,
        oldest_invoice_date:   oldestInvoiceDateStr,
      })
        .then((savedAction) => {
          const newEntry = {
            id:           savedAction.id,
            client_id:    clientId,
            action_type:  'follow_up_thibault',
            action_label: 'Follow-up Thibault',
            triggered_at: triggeredAt,
          };
          const current = this.recoveryActions[clientId] ? [...this.recoveryActions[clientId]] : [];
          this.$set(this.recoveryActions, clientId, [newEntry, ...current]);

          this.$swal({
            type: 'success',
            title: 'Follow-up envoyé',
            text: 'L\'action a été enregistrée et le webhook envoyé.',
            showConfirmButton: false,
            timer: 2500,
          });
        })
        .catch((err) => {
          console.error('Error on Follow-up Thibault:', err);
          this.$swal({
            type: 'error',
            title: 'Erreur',
            text: 'Une erreur est survenue. Veuillez réessayer.',
          });
        })
        .finally(() => {
          this.$set(this.followingUp, clientId, false);
        });
    },
  },
};
</script>

<style scoped>
.contenedor {
  padding: 20px;
}

.card {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #dee2e6;
}

.card-body {
  background-color: #fff;
}

.recovery-status-select {
  width: 260px;
}

.recovery-status-text {
  display: inline-block;
  background: #f28c00;
  color: #fff;
  border-radius: 4px;
  padding: 2px 5px;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
}

.recovery-status-edit {
  color: #a8a8a8;
  font-size: 14px;
  line-height: 1;
}

.recovery-status-confirm {
  color: #28a745;
  font-size: 15px;
  line-height: 1;
}

.comment-icon-warning img {
  filter: brightness(0) saturate(100%) invert(18%) sepia(87%) saturate(4582%) hue-rotate(348deg) brightness(91%) contrast(98%);
}

/* Ajustar tablas para que se adapten al contenido sin espacio sobrante */
.card-body .table-responsive {
  min-height: auto !important;
  height: auto !important;
  max-height: none !important;
  overflow-x: auto;
  overflow-y: visible;
}

.card-body table {
  margin-bottom: 0 !important;
}

.card-body .table-responsive table {
  margin-bottom: 0 !important;
}

/* Sobrescribir estilos globales que puedan estar afectando */
.card .card-body .table-responsive {
  min-height: auto !important;
  height: auto !important;
}

/* Asegurar que el tbody no tenga altura mínima */
.card-body table tbody {
  height: auto !important;
  min-height: auto !important;
}

/* Contenedor específico para las tablas de facturas */
.invoice-table-container {
  display: flex;
  flex-direction: column;
}

.invoice-table-container .table-responsive {
  flex: 0 1 auto;
  display: block;
}

/* Tab navigation inside cards */
.card-tabs-nav {
  display: flex;
  border-bottom: 0.5px solid rgba(0,0,0,0.15);
  background-color: #fff;
  padding: 0 16px;
}

.card-tab {
  display: inline-flex;
  align-items: center;
  padding: 10px 14px;
  font-size: 13.5px;
  font-weight: 400;
  color: #666;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  cursor: pointer;
  transition: color 0.15s;
}

.card-tab:hover {
  color: #1a1a1a;
  text-decoration: none;
}

.card-tab.active {
  font-weight: 500;
  color: #1a1a1a;
  border-bottom-color: #6B5FD4;
  text-decoration: none;
}

.tab-badge {
  background: #f0efea;
  color: #666;
  font-size: 11px;
  padding: 2px 7px;
  border-radius: 10px;
  margin-left: 6px;
  font-weight: 500;
}

/* Recovery Actions table */
.recovery-tab-body {
  padding: 0 8px 8px;
}

.recovery-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
}

.recovery-table thead tr {
  border-bottom: 0.5px solid rgba(0,0,0,0.15);
}

.recovery-table th {
  text-align: left;
  padding: 10px 8px;
  font-weight: 500;
  color: #666;
  font-size: 12.5px;
}

.recovery-table tbody tr {
  border-bottom: 0.5px solid rgba(0,0,0,0.08);
}

.recovery-table tbody tr:last-child {
  border-bottom: none;
}

.recovery-table td {
  padding: 11px 8px;
}

.action-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 500;
  padding: 3px 10px;
  border-radius: 6px;
}

.action-badge--email {
  background: #E6F1FB;
  color: #0C447C;
}

.action-badge--followup {
  background: #EEEDFE;
  color: #3C3489;
}

.action-date {
  color: #666;
  font-size: 13px;
}

/* Follow-up button inside Recovery Actions tab */
.recovery-tab-footer {
  padding: 16px 8px 12px;
  border-top: 0.5px solid rgba(0,0,0,0.12);
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.btn-followup-action {
  background: #6B5FD4;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: background 0.15s;
}

.btn-followup-action:hover:not(:disabled) {
  background: #5A4FC4;
}

.btn-followup-action:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
</style>
